export default "__VITE_ASSET__gmF9gdRE__"